/* eslint-disable @typescript-eslint/no-unused-vars */
import { faInfoCircle } from "@/icons/solid-icons";
import { cn } from "@/utils/css";
import TooltipWrapper from "../Tooltips/TooltipWrapper";
import TooltipContent from "../Tooltips/TooltipContent";
import type { IInput } from "@/types/library/Inputs";

const Input: React.FC<IInput> = ({
  id,
  value,
  onChange,
  label,
  inputType,
  placeholder,
  disabled,
  inputBackground = "bg-gray-100",
  inputClassName,
  labelClassName,
  wrapperClassName,
  isDefaultValue = true,
  pattern,
  maxLength,
  minLength,
  onKeyDown,
  customRef,
  description,
  min,
  max,
  tooltip,
  showTooltip = false,
  tabIndex = 0,
}) => {
  return (
    <div className={wrapperClassName}>
      {label && (
        <div
          className={cn(
            description ? "" : "mb-2",
            "flex items-center space-x-2",
          )}
        >
          <span className={cn("block", labelClassName)}>{label}</span>
          {showTooltip && (
            <div>
              <TooltipWrapper
                id={`${id}-tooltip`}
                content={
                  <TooltipContent
                    id={`${id}-tooltip-content`}
                    title={tooltip.labels.title}
                    info={tooltip.labels.description}
                    width={tooltip.labels.contentWidth}
                    buttonOnClick={tooltip.buttonOnClick}
                    buttonText={tooltip.labels.buttonText}
                    showButton={tooltip.showButton}
                  />
                }
                icon={faInfoCircle}
                interactive={tooltip.interactive}
                trigger={tooltip.trigger}
                position={tooltip.position}
              />
            </div>
          )}
        </div>
      )}
      {description && (
        <span
          className="mb-2 text-gray-500 text-xs"
          id={`${id}-description`}
          data-testid={`${id}-description`}
        >
          {description}
        </span>
      )}
      <input
        ref={customRef}
        className={cn(
          "w-full rounded-xl p-3 shadow-sm outline-none focus:border-0 focus:ring-2 focus:ring-dines-green",
          disabled ? "cursor-not-allowed opacity-30" : "",
          inputBackground,
          inputClassName,
          description ? "mt-2" : "",
        )}
        id={id}
        data-testid={id}
        placeholder={placeholder}
        type={inputType}
        pattern={pattern}
        minLength={minLength}
        maxLength={maxLength}
        min={min}
        max={max}
        disabled={disabled}
        tabIndex={tabIndex}
        onChange={(e) => {
          onChange(e);
        }}
        onBlur={(e) => {
          onChange(e);
        }}
        onKeyDown={onKeyDown}
        {...(isDefaultValue ? { defaultValue: value } : { value })}
      />
    </div>
  );
};

export default Input;
